import {connect} from 'react-redux';
import {withRouter} from "react-router-dom";
import {Menu} from "../../utils/menu/Menu";
import React, {useEffect, useState, useCallback} from "react";
import {toast} from "react-toastify";
import {formatErrors, roleChiefNutritionist, roleCurator, roleTrainee, userPrintName, userStatusFired} from "../../constants";
import {getSettingsAction, updateSettingsAction} from "../../actions/settingsAction";
import {usersAction} from "../../actions/usersAction";
import {InputCheckbox} from "../../utils/checkbox/InputCheckbox";
import {updateClientsFixCuratorAction} from "../../actions/clientAction";

const Settings = (props) => {
    const {getSettings, getUsers} = props;
    const [users, setUsers] = useState([]);
    const [clientsFix, setClientsFix] = useState([]);
    const [form, setForm] = useState(null);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    // get settings
    const getSettingsInfo = useCallback(() => {
        getSettings().then((data) => {
            setForm({
                id: data.admin_settings.id || 0,
                //customer_distribution: data.customer_distribution || 1,
                //customer_distribution_curator_id: data.customer_distribution_curator_id || '',
                //pin_users_with_installments: (data.pin_users_with_installments || '').split(',').reduce((res, i) => {
                //res[i] = true;
                //return res;
                //}, {}),
                pin_users_with_full: (data.admin_settings.pin_users_with_full || '').split(',').reduce((res, i) => {
                    res[i] = true;
                    return res;
                }, {}),
                pin_users_with_part: (data.admin_settings.pin_users_with_part || '').split(',').reduce((res, i) => {
                    res[i] = true;
                    return res;
                }, {}),
                pin_users_with_week: (data.admin_settings.pin_users_with_week || '').split(',').reduce((res, i) => {
                    res[i] = true;
                    return res;
                }, {}),
                clients_fix: data.clients_fix
            });
            //setClientsFix(data.clients_fix);
        }).catch(err => {
            toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
        });
    }, [getSettings]);

    // get users list
    const getUsersList = useCallback(() => {
        getUsers().then((data) => {
            let list = (data.list || []).map((i) => {
                let name = userPrintName(i);
                return {key: i.id, text: name, value: i.id};
            });
            setUsers(list);
        }).catch(err => {
            toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
        });
    }, [getUsers]);

    const handleChangeForm = (name, value) => {
        setForm({...form, [name]: value});
    };

    //const handleChangeCheckbox = (id, checked) => {
    //const pin_users_with_installments = {...form.pin_users_with_installments};
    //if (checked) {
    //pin_users_with_installments[id] = true;
    //} else if (pin_users_with_installments.hasOwnProperty(id)) {
    //delete pin_users_with_installments[id];
    //}
    //setForm({...form, pin_users_with_installments});
    //};

    const handleChangeCheckboxFull = (id, checked) => {
        const pin_users_with_full = {...form.pin_users_with_full};
        if (checked) {
            pin_users_with_full[id] = true;
        } else if (pin_users_with_full.hasOwnProperty(id)) {
            delete pin_users_with_full[id];
        }
        setForm({...form, pin_users_with_full});
    };

    const handleChangeCheckboxPart = (id, checked) => {
        const pin_users_with_part = {...form.pin_users_with_part};
        if (checked) {
            pin_users_with_part[id] = true;
        } else if (pin_users_with_part.hasOwnProperty(id)) {
            delete pin_users_with_part[id];
        }
        setForm({...form, pin_users_with_part});
    };

    const handleChangeCheckboxWeek = (id, checked) => {
        const pin_users_with_week = {...form.pin_users_with_week};
        if (checked) {
            pin_users_with_week[id] = true;
        } else if (pin_users_with_week.hasOwnProperty(id)) {
            delete pin_users_with_week[id];
        }
        setForm({...form, pin_users_with_week});
    };

    const handleSubmit = () => {
        if (loading) {
            return false;
        }
        let errs = {};
        //if (form.customer_distribution === 2 && !form.customer_distribution_curator_id) {
        //errs.customer_distribution_curator_id = true;
        //}

        if (Object.keys(form.pin_users_with_full).length === 1) {
            errs.pin_users_with_full = true;
        }

        if (Object.keys(form.pin_users_with_part).length === 1) {
            errs.pin_users_with_part = true;
        }

        if (Object.keys(form.pin_users_with_week).length === 1) {
            errs.pin_users_with_week = true;
        }

        setErrors(errs);
        if (Object.keys(errs).length > 0) {
            return;
        }

        setLoading(true);
        const data = {
            id: form.id,
            //customer_distribution: form.customer_distribution,
            //customer_distribution_curator_id: form.customer_distribution === 2 ? form.customer_distribution_curator_id : '',
            //pin_users_with_installments: Object.keys(form.pin_users_with_installments).join(',')
            pin_users_with_full: Object.keys(form.pin_users_with_full).join(','),
            pin_users_with_part: Object.keys(form.pin_users_with_part).join(','),
            pin_users_with_week: Object.keys(form.pin_users_with_week).join(','),
            //clients_fix: []
        };
        props.updateSettings(data).then(() => {
            setLoading(false);
            getSettingsInfo();
            toast.success('Изменения сохранены', {position: toast.POSITION.BOTTOM_RIGHT});
        }).catch((e) => {
            setLoading(false);
            toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
        });
    };

    const handleResetCuratorTemp = () => {
        if (loading) {
            return false;
        }

        setLoading(true);
        props.updateClientsFixCurator().then(() => {
            setLoading(false);
            getSettingsInfo();
            toast.success('Изменения сохранены', {position: toast.POSITION.BOTTOM_RIGHT});
        }).catch((e) => {
            setLoading(false);
            toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
        });
    }

    useEffect(() => {
        getUsersList();
    }, [getUsersList]);

    useEffect(() => {
        getSettingsInfo();
    }, [getSettingsInfo]);

    return <div className="content">
        <Menu isStatic={true}/>
        <div className="heading">
            <h2 className="heading__title">Настройки</h2>
        </div>

        {form && <div className="settings">
            <div className="settings__wrapper item-settings-wrapper">
                <h4 className="settings__title help">Закреплять пользователей с Full</h4>
                {
                    users.map((i) => {
                        return <InputCheckbox key={i.value} title={i.text} name={i.value}
                                              checked={form.pin_users_with_full[i.value] || false} disabled={loading}
                                              onChange={handleChangeCheckboxFull}/>
                    })
                }
            </div>
            <div className="settings__wrapper item-settings-wrapper">
                <h4 className="settings__title help">Закреплять пользователей с Part</h4>
                {
                    users.map((i) => {
                        return <InputCheckbox key={i.value} title={i.text} name={i.value}
                                              checked={form.pin_users_with_part[i.value] || false} disabled={loading}
                                              onChange={handleChangeCheckboxPart}/>
                    })
                }
            </div>
            <div className="settings__wrapper item-settings-wrapper">
                <h4 className="settings__title help">Закреплять пользователей с Week</h4>
                {
                    users.map((i) => {
                        return <InputCheckbox key={i.value} title={i.text} name={i.value}
                                              checked={form.pin_users_with_week[i.value] || false} disabled={loading}
                                              onChange={handleChangeCheckboxWeek}/>
                    })
                }
            </div>
            <div className="settings__wrapper item-settings-wrapper-clear">
                <button type="button" className="settings__btn btn" onClick={handleSubmit}>Сохранить</button>
            </div>
        </div>}
    </div>;
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
    return {
        getSettings() {
            return dispatch(getSettingsAction());
        },
        updateSettings(data) {
            return dispatch(updateSettingsAction(data));
        },
        getUsers() {
            return dispatch(usersAction({
                page: 1,
                limit: 1000,
                search: '',
                block_user: 2,
                not_status: userStatusFired,
                // role_id: roleCurator
                roles_ids: [roleCurator, roleTrainee, roleChiefNutritionist]
            }));
        },
        updateClientsFixCurator(id, dayOff) {
            return dispatch(updateClientsFixCuratorAction());
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Settings))
